import React from "react";
import "./FacebookEmbed.css";
import Container
    from "./Container";
const FacebookEmbed = () => {
    return (<div><Container>
        <div className="social-header">
            <h1>Kövess minket Facebookon!</h1>
            <p>
                A legfrissebb infók és képek elérhetőek a Facebook oldalunkon, kövess minket, hogy ne maradj le semmiről!
            </p>
        </div>
    </Container>
        <div className="facebook-embed">
            <iframe
                title="Facebook Page"
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61574211908652&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
                width="500"
                height="600"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                allowFullScreen={true}
            ></iframe>
        </div></div>
    );
};

export default FacebookEmbed;
